export const storeTypes = [
  {
    mccCode: "5921",
    name: "Liquor Store",
    value: "liquor",
  },
  {
    mccCode: "5921",
    name: "Bottle Shops & Beer Seller",
    value: "beerSeller",
  },
  {
    mccCode: "5921",
    name: "Wine Merchant",
    value: "wineMerchant",
  },
  {
    mccCode: "5921",
    name: "Specialty Spirits Outlet",
    value: "specialtySpiritsOutlet",
  },
  {
    mccCode: "5541",
    name: "Standalone Fuel Station",
    value: "standaloneFuelStation",
  },
  {
    mccCode: "5541",
    name: "Fuel and Convenience Station",
    value: "fuelAndConvenienceStation",
  },
  {
    mccCode: "5541",
    name: "Fuel and Car Wash",
    value: "fuelAndCarWash",
  },
  {
    mccCode: "5499",
    name: "Convenience Store/Market",
    value: "convenienceStoreMarket",
  },
  {
    mccCode: "5499",
    name: "Specialty Store",
    value: "specialtyStore",
  },
  {
    mccCode: "5411",
    name: "Grocery Store",
    value: "groceryStore",
  },
  {
    mccCode: "5411",
    name: "Supermarket",
    value: "supermarket",
  },
  {
    mccCode: "5813",
    name: "Bar/Pub/Tavern",
    value: "barPubTavern",
  },
  {
    mccCode: "5813",
    name: "Night Club",
    value: "nightClub",
  },
  {
    mccCode: "5813",
    name: "Entertainment Venue w/ Bar",
    value: "entertainmentVenueBar",
  },
  {
    mccCode: "5812",
    name: "Restaurant",
    value: "restaurant",
  },
  {
    mccCode: "5814",
    name: "Fast Food Restaurant",
    value: "fastFoodRestaurant",
  },
  {
    mccCode: "7542",
    name: "Car Wash (non fuel)",
    value: "carWashNonFuel",
  },
];
